import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './views/Login/Login';
import Home from './views/Home/Home';
import OriginLocation from './views/InternalTransfer/OriginLocation/OriginLocation';
import AddPackage from './views/InternalTransfer/AddPackages/AddPackages';
import LocationScan from './views/InventoryTaking/LocationScan/LocationScan';
import PackageInquiry from './views/PackageInquiry/PackageInquiry';
import PackageScan from './views/InventoryTaking/PackagesScan/PackageScan';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import { DEVICE_CONFIG } from "./constants/deviceConfig";
import { getSession, isTokenExpired } from './utils/auth';
import PackageList from './views/InventoryTaking/PackageList/PackageList';

document.documentElement.style.setProperty("--screen-width", `${DEVICE_CONFIG.SCREEN_WIDTH}px`);
document.documentElement.style.setProperty("--screen-height", `${DEVICE_CONFIG.SCREEN_HEIGHT}px`);
document.documentElement.style.setProperty("--base-font", `${DEVICE_CONFIG.BASE_FONT_SIZE}px`);


function App() {

  return (
    <Router>

      <div className="app">

        <Routes>

          <Route 
            path="/" 
            element={<Login />}
          />

          <Route 
            path="/home" 
            element={
                <ProtectedRoute>
                    <Home />
                </ProtectedRoute>
            } 
          />

          <Route 
            path="/originlocation"
            element={
                <ProtectedRoute>
                    <OriginLocation />
                </ProtectedRoute>
            }
          />

          <Route 
            path="/addpackages"
            element={
                <ProtectedRoute>
                    <AddPackage />
                </ProtectedRoute>
            }
          />

          <Route 
            path="/locationscan"
            element={
                <ProtectedRoute>
                    <LocationScan />
                </ProtectedRoute>
            }
          />

          <Route 
            path="/packagescan"
            element={
                <ProtectedRoute>
                    <PackageScan />
                </ProtectedRoute>
            }
          />

          <Route 
            path="/packageinquiry"
            element={
                <ProtectedRoute>
                    <PackageInquiry />
                </ProtectedRoute>
            }
          />

          <Route 
            path="/packagelist"
            element={
                <ProtectedRoute>
                    <PackageList />
                </ProtectedRoute>
            }
          />

        </Routes>

      </div>

    </Router>
  );
}

export default App;